import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { Jurisdiction } from '/@/modules/predefined/models/Jurisdiction';
import { commits, getters } from '/@/modules/core/app/helpers/store';
import { removeAccents } from '/@/modules/core/app/helpers/StringHelper';

export class JurisdictionService extends BaseEntityService {
  getRoute() {
    return Route.PREDEFINED_JURISDICTIONS;
  }

  getModel() {
    return Jurisdiction;
  }

  /**
   * @param {object} params
   * @returns {Array.<Jurisdiction>}
   */
  async getItems(params = {}) {
    let items = getters.predefined.getJurisdictions();
    if (items) {
      return items;
    }

    items = await this.getEntities(params);
    commits.predefined.setJurisdictions(items);
    return items;
  }

  /**
   * @param {number} countryId
   * @param {string|null} administrativeDivisionDescriptor
   * @returns {Array.<Jurisdiction>}
   */
  getJurisdictionsByCountry(countryId, administrativeDivisionDescriptor = null) {
    return getters.predefined.getJurisdictions().filter((jurisdiction) => {
      if (administrativeDivisionDescriptor) {
        return (
          jurisdiction.countryId === countryId &&
          jurisdiction.administrativeDivisionDescriptor === administrativeDivisionDescriptor
        );
      }
      return jurisdiction.countryId === countryId;
    });
  }

  /**
   * @param {string} name
   * @returns {Jurisdiction}
   */
  getJurisdictionByName(name) {
    return getters.predefined
      .getJurisdictions()
      .find((jurisdiction) => removeAccents(jurisdiction.name) === removeAccents(name));
  }

  /**
   * @param {number} id
   * @returns {Jurisdiction}
   */
  getJurisdictionById(id) {
    return getters.predefined.getJurisdictions().find((jurisdiction) => jurisdiction.id === id);
  }

  /**
   * @param {number} id
   * @returns {boolean}
   */
  isUSJurisdiction(id) {
    return getters.predefined.isUSJurisdiction(id);
  }
}

export default new JurisdictionService();
